import { datadogRum } from '@datadog/browser-rum'

/**
 * Log at error level
 * @param error Error to log
 * @param context Context to log
 */
export const logError = (
  error: unknown,
  context?: Record<string, unknown>
): void => {
  const VITE_LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL

  if (VITE_LOG_LEVEL.includes('error')) {
    switch (import.meta.env.MODE) {
      case 'development':
        // eslint-disable-next-line no-console
        console.error(error, context)
        break

      default:
        datadogRum.addError(error, context)
        break
    }
  }
}
